export default __webpack_public_path__ + "static/media/fire-alarms-icon.89407f46.svg";